export default "__VITE_ASSET__BnmIfVWO__"